/**
 * Custom glove grouped cart handlers for Refresh (Dawn-family).
 * Uses /cart/change.js + publish(PUB_SUB_EVENTS.cartUpdate).
 * Prefers cart-drawer over cart-notification when refreshing.
 */
(function () {
  'use strict';

  if (window.customGloveCartInitialized) return;
  window.customGloveCartInitialized = true;

  function routes() {
    return window.routes || {};
  }

  function refreshCart() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-glove-cart' });
    }

    // Prefer open cart-drawer; fall back to active cart-notification.
    // Skip renderContents when drawer is closed so cart-page qty/remove doesn't force-open it.
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');
    var cart = null;

    if (cartDrawer && cartDrawer.classList.contains('active')) {
      cart = cartDrawer;
    } else if (cartNotification && cartNotification.classList.contains('active')) {
      cart = cartNotification;
    }

    if (!cart || typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') {
      return;
    }

    var sectionIds = cart.getSectionsToRender().map(function (s) {
      return s.id;
    });

    fetch((routes().cart_url || '/cart') + '?sections=' + sectionIds.join(','))
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var sections = (data && data.sections) || data;
        if (sections) {
          cart.renderContents({
            id: null,
            sections: sections,
          });
        }
      })
      .catch(function (err) {
        console.error('Custom glove cart: drawer refresh failed', err);
      });
  }

  function getGroupKeys(assocKey) {
    return fetch((routes().cart_url || '/cart') + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var keys = [];
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          if (props._AssociationKey === assocKey || props._ParentKey === assocKey) {
            keys.push(item.key);
          }
        });
        return keys;
      });
  }

  function setQuantities(keys, quantity) {
    var changeUrl = routes().cart_change_url || '/cart/change.js';
    return Promise.all(
      keys.map(function (key) {
        return fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
      })
    );
  }

  function removeGroup(assocKey) {
    return getGroupKeys(assocKey).then(function (keys) {
      if (!keys.length) {
        refreshCart();
        return;
      }
      return setQuantities(keys, 0).then(function () {
        refreshCart();
      });
    });
  }

  function updateGroupQty(assocKey, quantity) {
    return getGroupKeys(assocKey).then(function (keys) {
      if (!keys.length) {
        refreshCart();
        return;
      }
      return setQuantities(keys, quantity).then(function () {
        refreshCart();
      });
    });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.cart-group-remove-btn');
    if (!removeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var assocKey = removeBtn.dataset.assocKey;
    if (!assocKey) return;

    removeBtn.disabled = true;
    removeGroup(assocKey).finally(function () {
      removeBtn.disabled = false;
    });
  });

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('cart-glove-group-qty-input')) return;

      e.stopPropagation();

      var assocKey = input.dataset.assocKey;
      if (!assocKey) return;

      var qty = parseInt(input.value, 10) || 0;
      if (qty === 0) {
        removeGroup(assocKey);
        return;
      }

      input.disabled = true;
      updateGroupQty(assocKey, qty).finally(function () {
        input.disabled = false;
      });
    },
    true
  );
})();
